import { VERNACULAR_DEFAULT_MESSAGES } from "constants/vernacularConstants";


interface ValidationReturnType{
     error: string,
     hasError: boolean,
}

export const validateVPAField = (value:string|null, errors?: {required: string, invalid: string}): ValidationReturnType => {
  let error = "";
  let hasError = false;
  if (!value) {
    error = errors?.required || VERNACULAR_DEFAULT_MESSAGES.THIS_FIELD_IS_REQUIRED;
    hasError = true;
  } else if (!/^[\\.A-Za-z0-9-]+@[A-Za-z0-9]{2,}$/.test(value)) {
    error = errors?.invalid || VERNACULAR_DEFAULT_MESSAGES.UPI_ADDRESS_NOT_VALID;
    hasError = true;
  } else {
    error = "";
  }

  return {
    error,
    hasError,
  };
};
